<template>
  <div id="immo_framework">
  <iframe id="immoFrame" src="https://home.immobilienscout24.de/1217804/offers//listed/Aktualität/0#realEstates" style="width: 90vw; height: 75vh; border: 0px;" />
  </div>
</template>

<script>
export default {
    mounted() {
        this.$ga.page('/AngeboteImmoScout')
        this.$ga.screenview('angebote / immoscout')
        fetch('https://home.immobilienscout24.de/1217804/offers//listed/Aktualität/0#realEstates', {
            method: 'GET',
            mode: 'no-cors',
            credentials: 'include',
            redirect: 'follow',
            referrerPolicy: 'origin-when-cross-origin'
        })
    },
}

</script>

<style>
</style>
